import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { CancellationPlanEnum } from '../pdp-ecolodge.model';

@Component({
 selector: 'iho-pdp-ecolodge-policies-dialog',
 standalone: true,
 imports: [CommonModule, MatExpansionModule],
 templateUrl: './pdp-ecolodge-policies-dialog.component.html',
 styleUrls: ['./pdp-ecolodge-policies-dialog.component.scss'],
})
export class PdpEcolodgePoliciesDialogComponent {
    tabs = [
        'روزهای عادی',
        'روزهای پیک'
    ]
    
    easyCancellationDto = {
        normalDayDto: [
            {
                title: 'قبل از تحویل اقامتگاه',
                conditions: [
                    {
                        title: 'قبل از روز شروع رزرو',
                        description: 'کسر ۱۰٪ از مبلغ رزرو به عنوان خسارت، بازگشت باقی مانده مبلغ به شما'
                    },
                    {
                        title: 'روز شروع اقامت قبل از تحویل',
                        description: 'کسر ۲۰٪ از مبلغ رزرو به عنوان خسارت، بازگشت باقی مانده مبلغ به شما'
                    }
                ]
            },
            {
                title: 'بعد از تحویل اقامتگاه',
                conditions: [
                    {
                        title: 'در حین اقامت',
                        description: 'کسر مبلغ شب های اقامت داشته + مبلغ ۱۰٪ از مابقی مبلغ به عنوان خسارت، بازگشت مبلغ باقی مانده به شما'
                    }
                ]
            },
            {
                title: 'شرایط زمانی خاص',
                conditions: [
                    {
                        title: 'ایام نوروز',
                        description: 'تا قبل از ۱۵ اسفند کسر ۲۰٪ از کل مبلغ و بازگشت باقی مانده به شما ، بعد از ۱۵ اسفند هیچ مبلغی عودت داده نمی‌شود'
                    },
                    {
                        title: 'لغو رزرو بلند مدت (بیش از ۱۴ روز)',
                        description: 'کسر مبلغ ۳ شب اول + ۲۰٪ از مابقی مبلغ رزرو به عنوان خسارت، بازگشت مبلغ باقی مانده به شما'
                    }
                ]
            }
        ],
        peakDayDto: [
            {
                title: 'قبل از تحویل اقامتگاه',
                conditions: [
                    {
                        title: 'بیش از 3 روز مانده به شروع اقامت',
                        description: 'کسر مبلغ ۲۰٪ از کل مبلغ به عنوان خسارت، بازگشت باقی مانده مبلغ به شما'
                    },
                    {
                        title: 'کمتر از 3 روز مانده به شروع اقامت',
                        description: 'هزینه ای به شما عودت داده نمی‌شود'
                    }
                ]
            },
            {
                title: 'بعد از تحویل اقامتگاه',
                conditions: [
                    {
                        title: 'در حین اقامت',
                        description: 'هزینه ای به شما عودت داده نمی‌شود'
                    }
                ]
            },
            {
                title: 'شرایط زمانی خاص',
                conditions: [
                    {
                        title: 'ایام نوروز',
                        description: 'تا قبل از ۱۵ اسفند کسر ۲۰٪ از کل مبلغ و بازگشت باقی مانده به شما ، بعد از ۱۵ اسفند هیچ مبلغی عودت داده نمی‌شود'
                    },
                    {
                        title: 'لغو رزرو بلند مدت (بیش از ۱۴ روز)',
                        description: 'کسر مبلغ ۳ شب اول + ۲۰٪ از مابقی مبلغ رزرو به عنوان خسارت، بازگشت مبلغ باقی مانده به شما'
                    }
                ]
            }
        ]
    }
    
    normalCancellationDto = {
        normalDayDto: [
            {
                title: 'قبل از تحویل اقامتگاه',
                conditions: [
                    {
                        title: 'بیشتر از ۳ روز مانده به شروع اقامت',
                        description: 'کسر ۱۰٪ مبلغ کل رزرو به عنوان خسارت، بازگشت باقی مانده مبلغ به شما'
                    },
                    {
                        title: 'کمتر از ۳ روز مانده به شروع اقامت',
                        description: 'کسر مبلغ شب اول + ۱۰٪ از مابقی مبلغ به عنوان خسارت، بازگشت باقی مانده مبلغ به شما'
                    },
                    {
                        title: 'روز شروع اقامت قبل از تحویل',
                        description: 'کسر مبلغ ۲ شب اول + ۱۰٪ از مابقی مبلغ به عنوان خسارت، بازگشت باقی مانده مبلغ به شما'
                    }
                ]
            },
            {
                title: 'بعد از تحویل اقامتگاه',
                conditions: [
                    {
                        title: 'در حین اقامت',
                        description: 'کسر مبلغ شب های اقامت داشته + مبلغ شب بعدی + مبلغ ۱۰٪ از مابقی مبلغ به عنوان خسارت، بازگشت مبلغ باقی مانده به شما'
                    }
                ]
            },
            {
                title: 'شرایط زمانی خاص',
                conditions: [
                    {
                        title: 'ایام نوروز',
                        description: 'تا قبل از ۱۵ اسفند کسر ۲۰٪ از کل مبلغ و بازگشت باقی مانده به شما ، بعد از ۱۵ اسفند هیچ مبلغی عودت داده نمی‌شود'
                    },
                    {
                        title: 'لغو رزرو بلند مدت (بیش از ۱۴ روز)',
                        description: 'کسر مبلغ ۵ شب اول + ۲۰٪ از مابقی مبلغ رزرو به عنوان خسارت، بازگشت مبلغ باقی مانده به شما'
                    }
                ]
            }
        ],
        peakDayDto: [
            {
                title: 'قبل از تحویل اقامتگاه',
                conditions: [
                    {
                        title: 'بیش از ۵ روز مانده به شروع اقامت',
                        description: 'کسر مبلغ ۲۰٪ از کل مبلغ به عنوان خسارت، بازگشت باقی مانده مبلغ به شما'
                    },
                    {
                        title: 'کمتر از ۵ روز مانده به شروع اقامت',
                        description: 'هزینه ای به شما عودت داده نمی‌شود'
                    }
                ]
            },
            {
                title: 'بعد از تحویل اقامتگاه',
                conditions: [
                    {
                        title: 'در حین اقامت',
                        description: 'هزینه ای به شما عودت داده نمی‌شود'
                    }
                ]
            },
            {
                title: 'شرایط زمانی خاص',
                conditions: [
                    {
                        title: 'ایام نوروز',
                        description: 'تا قبل از ۱۵ اسفند کسر ۲۰٪ از کل مبلغ و بازگشت باقی مانده به شما ، بعد از ۱۵ اسفند هیچ مبلغی عودت داده نمی‌شود'
                    },
                    {
                        title: 'لغو رزرو بلند مدت (بیش از ۱۴ روز)',
                        description: 'کسر مبلغ ۵ شب اول + ۲۰٪ از مابقی مبلغ رزرو به عنوان خسارت، بازگشت مبلغ باقی مانده به شما'
                    }
                ]
            }
        ]
    }

    hardCancellationDto = {
        normalDayDto: [
            {
                title: 'قبل از تحویل اقامتگاه',
                conditions: [
                    {
                        title: 'بیش از 7 روز مانده به شروع اقامت',
                        description: 'کسر مبلغ شب اول + 10% از مابقی مبلغ به عنوان خسارت، بازگشت باقی مانده مبلغ به شما'
                    },
                    {
                        title: 'کمتر از 7 روز مانده به شروع اقامت',
                        description: 'کسر مبلغ 2شب اول + 10% از مابقی مبلغ به عنوان خسارت، بازگشت باقی مانده مبلغ به شما'
                    },
                    {
                        title: 'روز شروع اقامت قبل از تحویل',
                        description: 'هزینه ای به شما عودت داده نمی‌شود'
                    }
                ]
            },
            {
                title: 'بعد از تحویل اقامتگاه',
                conditions: [
                    {
                        title: 'در حین اقامت',
                        description: 'هزینه ای به شما عودت داده نمی‌شود'
                    }
                ]
            },
            {
                title: 'شرایط زمانی خاص',
                conditions: [
                    {
                        title: 'ایام نوروز',
                        description: 'تا قبل از ۱۵ اسفند کسر ۲۰٪ از کل مبلغ و بازگشت باقی مانده به شما ، بعد از ۱۵ اسفند هیچ مبلغی عودت داده نمی‌شود'
                    },
                    {
                        title: 'لغو رزرو بلند مدت (بیش از ۱۴ روز)',
                        description: 'کسر مبلغ ۷ شب اول + ۲۰٪ از مابقی مبلغ رزرو به عنوان خسارت، بازگشت مبلغ باقی مانده به شما'
                    }
                ]
            }
        ],
        peakDayDto: [
            {
                title: 'قبل از تحویل اقامتگاه',
                conditions: [
                    {
                        title: 'بیش از 10 روز مانده به شروع اقامت',
                        description: 'کسر مبلغ شب اول + 20% از مابقی مبلغ به عنوان خسارت، بازگشت باقی مانده مبلغ به شما'
                    },
                    {
                        title: 'کمتر از 10 روز مانده به شروع اقامت',
                        description: 'هزینه ای به شما عودت داده نمی‌شود'
                    }
                ]
            },
            {
                title: 'بعد از تحویل اقامتگاه',
                conditions: [
                    {
                        title: 'در حین اقامت',
                        description: 'هزینه ای به شما عودت داده نمی‌شود'
                    }
                ]
            },
            {
                title: 'شرایط زمانی خاص',
                conditions: [
                    {
                        title: 'ایام نوروز',
                        description: 'تا قبل از ۱۵ اسفند کسر ۲۰٪ از کل مبلغ و بازگشت باقی مانده به شما ، بعد از ۱۵ اسفند هیچ مبلغی عودت داده نمی‌شود'
                    },
                    {
                        title: 'لغو رزرو بلند مدت (بیش از ۱۴ روز)',
                        description: 'کسر مبلغ ۷ شب اول + ۲۰٪ از مابقی مبلغ رزرو به عنوان خسارت، بازگشت مبلغ باقی مانده به شما'
                    }
                ]
            }
        ]
    }

    dto: any



    activatedTab = 1
    calculatedRightNavigator = 0
    cancellationPlanEnum = CancellationPlanEnum

    constructor(
        public dialogRef: MatDialogRef<PdpEcolodgePoliciesDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public cancellationPlan: number,
    ) {
        if (this.cancellationPlan == this.cancellationPlanEnum.Easy) {
            this.dto = this.easyCancellationDto
        }
        if (this.cancellationPlan == this.cancellationPlanEnum.Normal) {
            this.dto = this.normalCancellationDto
        }
        if (this.cancellationPlan == this.cancellationPlanEnum.Hard) {
            this.dto = this.hardCancellationDto
        }
    }

    onTabClicked(index: number) {
        this.activatedTab = index + 1
        this.calculatedRightNavigator = 100 / this.activatedTab === 100 ? 0 : 100 / this.activatedTab
    }
}
